const MAX_RESUMO = 400;
const corta = (t, n) => (t.length > n ? t.slice(0, n - 1) + "…" : t);
/** Resumo sem IA: o que a pessoa perguntou, somado ao resumo anterior. Os passos e os artigos ficam de fora. */
export function compactarContexto(turnos, anterior = "") {
  const perguntas = turnos.filter((t) => t.papel === "pessoa").map((t) => `"${corta(t.texto.trim(), 80)}"`);
  if (!perguntas.length) return anterior;
  const novo = `A pessoa perguntou ${perguntas.slice(0, 3).join("; ")} e o problema foi resolvido.`;
  return corta([anterior, novo].filter(Boolean).join(" ").slice(-MAX_RESUMO), MAX_RESUMO);
}
